const initialSate = () => ({
  hasLoaded: false,
  userName: '',
  userId: 0,
  isAdmin: false,
});

export default initialSate;
